import {MI} from "../init";

/**
 * @constructor
 * @returns {LinesInfo}
 */
export function LinesInfo() {

    /** @type {MadnesObject} */
    this._table;

    this._x = [110, 142, 175, 209, 242];
    this._y = [8, 30, 53];

    for(var i = 0; i < this._x.length; i++) {
        this._x[i] = this._x[i] - (335 / 2);
    }

//	for(var i = 0; i < this._y.length; i++) {
//		this._y[i] = this._y[i];
//	}

    var p = [];

    for(var i = 0; i < 15; i++) {
        p.push({ 'x': this._x[i % 5], 'y': this._y[(i / 5) | 0] });
    }

    /*for(var i = 0; i < 20; i++) {
        lines.push();
    }*/

    /** @type {Object<string, Array>} */
    this._lines = {
        '0': [ p[5], p[6], p[7], p[8], p[9] ],
        '1': [ p[0], p[1], p[2], p[3], p[4] ],
        '2': [ p[10], p[11], p[12], p[13], p[14] ],
        '3': [ p[0], p[6], p[12], p[8], p[4] ],
        '4': [ p[10], p[6], p[2], p[8], p[14] ],
        '5': [ p[5], p[11], p[12], p[13], p[9] ],
        '6': [ p[5], p[1], p[2], p[3], p[9] ],
        '7': [ p[10], p[11], p[7], p[3], p[4] ],
        '8': [ p[0], p[1], p[7], p[13], p[14] ],
        '9': [ p[10], p[6], p[7], p[8], p[4] ],
        '10': [ p[0], p[6], p[7], p[8], p[14] ],
        '11': [ p[5], p[11], p[7], p[3], p[9] ],
        '12': [ p[5], p[1], p[7], p[13], p[9] ],
        '13': [ p[0], p[6], p[2], p[8], p[4] ],
        '14': [ p[10], p[6], p[12], p[8], p[14] ],
        '15': [ p[5], p[6], p[2], p[8], p[9] ],
        '16': [ p[5], p[6], p[12], p[8], p[9] ],
        '17': [ p[0], p[11], p[2], p[13], p[4] ],
        '18': [ p[10], p[1], p[12], p[3], p[14] ],
        '19': [ p[10], p[1], p[7], p[3], p[14] ]
    };

    /** @type {Array<MadnesObject>} */
    this._dots = [];

    /** @type {boolean} */
    this._hided = true;

    /** @type {MadnesTween} */
    this._tweenShow;
    /** @type {MadnesTween} */
    this._tweenHide;

    this._hideY = -110;
};

LinesInfo.prototype.create = function() {
    this._table = MI.addImg(MI.getWi() / 2 - 8, this._hideY, "reels_atlas").setFrameName("lines_backgorund");
    this._table.setAnchor(0.5, 0);
    this._hided = true;
};

//LinesInfo.prototype.debug = function() {
//	var _self = this;
//
//	this._clearDots();
//
//	for(var i = 0; i < this._x.length; i++) {
//
//		for(var j = 0; j < this._y.length; j++) {
//			var dotImg = MI.addImg(this._x[i], this._y[j], "reels_atlas").setFrameName("lines_light");
//			dotImg.setAnchor(0.5, 0.5);
//			_self._table.addChild(dotImg);
//			_self._dots.push(dotImg);
//		}
//	}
//};

LinesInfo.prototype.drawLine = function(num) {
    var _self = this;

    //console.log(num);

    this._clearDots();

    return new Promise(function(res) {
        var line = _self._lines[num];

        for(var i = 0; i < line.length; i++) {

            (function(i) {
                setTimeout(function() {
                    var pos = line[i];
                    var dotImg = MI.addImg(pos['x'], pos['y'], "reels_atlas").setFrameName("lines_light");
                    dotImg.setAnchor(0.5, 0.5);
                    _self._table.addChild(dotImg);
                    _self._dots.push(dotImg);

                    if(i === line.length - 1) {
                        res();
                    }

                }, i * 40);
            } (i));
        }
    });
};

LinesInfo.prototype._clearDots = function() {

    for(var i = 0; i < this._dots.length; i++) {
        this._dots[i].destroy();
    }

    this._dots.length = 0;
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
LinesInfo.prototype.show = function(duration) {
    var _self = this;

    if(typeof duration === 'undefined') { duration = 200 };

    return new Promise(function(res) {

        _self._tweenHide && _self._tweenHide.stop();

        _self._table.revive();

        if(!_self._hided) {
            res();
            return;
        }

        _self._tweenShow = MI.addTween().to(_self._table, { 'y': 0 }, {
            'duration': duration,
            'callback': function() {
                _self._table.setPosY(0);
                _self._hided = false;
                res();
            }
        });
    });
};

/**
 * @param {number=} duration
 * @returns {Promise}
 */
LinesInfo.prototype.hide = function(duration) {
    var _self = this;

    if(typeof duration === 'undefined') { duration = 200 };

    return new Promise(function(res) {

        _self._tweenShow && _self._tweenShow.stop();

        if(_self._hided) {
            res();
            return;
        }

        _self._tweenHide = MI.addTween().to(_self._table, { 'y': _self._hideY }, {
            'duration': duration,
            'callback': function() {
                _self._table.setPosY(_self._hideY);
                _self._table.kill();
                _self._clearDots();
                _self._hided = true;
                res();
            }
        });
    });
};